"use strict";

exports.__esModule = true;
exports.default = void 0;
var breakPoints = {
  mobile: '320px',
  mobileMax: '767px',
  largeMobile: '420px',
  tablet: '768px',
  smallDesktop: '992px',
  desktop: '1280px'
};
/** @component */

var _default = breakPoints;
exports.default = _default;